import { defineStore } from 'pinia';

import { useLocalStorage } from '@vueuse/core';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';

const SSO_AUTH_URL = process.env.VUE_APP_API_URL + '/auth/sso';
const SSO_AVAILABILITY = process.env.VUE_APP_API_URL + '/auth/available';


export const useSSOStore = defineStore('ssoAuth', {
    state: () => ({
        user: useLocalStorage('ssoUser', {}),
        token: useLocalStorage('ssoToken', null),
        email: useLocalStorage('email', null),
        loader: false,
        showLoginFields: false, // Tracks whether to show login fields
    }),

    getters: {
        isAuthenticated: (state) => !!state.token,
    },

    actions: {
        async checkSSO() {
            if (!this.email) {
                showToast({}, 'Please enter your email');
                return;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.email)) {
                showToast({ severity: "warn", summary: "Invalid Email" }, "Please enter a valid email address");
                return;
            }

            try {
                const response = await authApi.post(SSO_AVAILABILITY, { email:this.email });
                if (response.data) {
                  this.initiateSSO()
                } else {
                    this.showLoginFields = true
                }
            } catch (error) {
                // showToast({}, 'Error checking SSO availability');
            }
        },

        async initiateSSO() {
            if (!this.email) {
                showToast({ severity: "warn", summary: "Alert" }, "Please enter an email for SSO");
                return;
            }

            try {
                const response = await fetch(SSO_AUTH_URL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email: this.email })
                });

                const result = await response.json();
                if (result.url) {
                    window.location.href = result.url;
                } else {
                    showToast({ severity: "error", summary: "Error" }, "SSO failed. No redirect URL.");
                }
            } catch (error) {
                showToast({ severity: "error", summary: "Error" }, "Something went wrong during SSO.");
            }
        },



    }
});
